// extracted by mini-css-extract-plugin
module.exports = {"summary__item":"J_cM","summary__item__name":"J_cN","summary__item__price":"J_cP","summary__col__wrap":"J_cQ","summary__quantity":"J_cR"};